import axios from "axios";
import React, {Component} from "react";
import Select from 'react-select';
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

class   UpdateManifesteForm extends Component{

    state = {
        id : null,
        coli : null,
        error : "",
        quantity : null,
        qtMax : null,
        showform : false,

        colis : [],
        btn  : false
    }

    componentDidMount(){
        this.getColis()
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    async getColis(){
        let request = await axios.get('/colis/status/EnStock');
        if(request.status === 200){
            this.setState({  colis : request.data  })
        }
    }

    storeData = (e) =>{
        e.preventDefault();
        let qt = parseFloat(this.state.quantity  || 0)
        if(parseFloat(this.state.qtMax || 0) >= qt && qt > 0){
            let coli = this.state.coli
            coli.expedie = parseFloat(coli.expedie || 0) + qt
            coli.stock = parseFloat(coli.stock || 0) - qt
            
            for (let index = 0; index < coli.colidetails?.length; index++) {
                let val = coli.colidetails[index]
                if(qt > 0){
                    val.expedie = parseFloat(val.stock || 0) > qt ? qt : parseFloat(val.stock)
                    qt -= parseFloat(val.stock || 0) > qt ? qt : parseFloat(val.stock)
                    coli.colidetails[index] = val
                }
            }
        
            let data = {
                manifesteId : this.props.formData?.manifeste?.id,
                colis : [coli]
            }
    
            this.setState({
                btn : !this.state.btn
            })
    
            axios.post('manifestecolis/', data).then((response) =>{
                this.setState({
                    btn : !this.state.btn
                })
                toast(response.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
                this.props.showModal(1)
            }).catch((error) => {
                this.setState({
                    error : error.response?.data?.msg,
                    btn : !this.state.btn
                })
                toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
            })
        }else
            toast("La quantité est invalide svp. " + this.state.qtMax + " est la qté maximale", { theme : "light", style : { backgroundColor : "red", color : "white"}})
    }

    deleteManifesteColi = (manifestecoliId) => {
        if(window.confirm("Le retrait du coli sur le manifeste est irreversible!") == true){
            if(manifestecoliId){
                    axios.delete("manifestecolis/" + manifestecoliId).then((response) => {
                        this.props.showModal(1)
                        toast(response.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
                    }).catch(error => {
                        toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
                    })
            }else
                toast("Les donnees sont invalides!", { theme : "light", style : { backgroundColor : "red", color : "white"}})
        }
    }
    
    handleCheck(val) {
        var permissions = JSON.parse(localStorage.getItem("permissions")) ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some(item => val === item.name)
    }
    
    render(){

        let coliTables = [] 
        this.state.colis?.sort((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? 1 : -1).map((val) => {
            coliTables.push({...val, label : val.ref_coli + " " + val.client?.name + " (" + val.quantity + ")" })
        })

        let colis = 
        this.props.formData?.manifeste?.manifestecolis?.sort((a, b) => a.coli?.ref_coli > b.coli.ref_coli ? 1 : -1).map((manifestecoli, count) => {
            
            return(
                <tr>
                    <td>{ count+1} </td>
                    <td><label htmlFor={count}><Link to={"/profile/" + manifestecoli.coli?.client?.id }>{ manifestecoli.coli?.client?.name }</Link> </label></td>
                    <td><Link to="#" onClick={ () => this.deleteManifesteColi(manifestecoli.id)}>{ manifestecoli.coli?.ref_coli } <small className={ manifestecoli.coli?.status == "Manifeste" ? "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-blue-1-05 text-blue-1 table_action" : manifestecoli.coli?.status == "EnStock" ? "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-yellow-4 text-yellow-3 table_action" : "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-green-1 text-green table_action"}>{ manifestecoli.coli?.status != "Manifeste" ? manifestecoli.coli?.status : "" } </small></Link></td>
                    <td><label htmlFor={count}>{ manifestecoli.coli?.expedie }</label></td>
                    <td><label htmlFor={count}>{ manifestecoli.price?.toLocaleString() }</label></td>
                    <td><label htmlFor={count}>{ manifestecoli.manifestecolidetails?.map((manifestecolidetail) => { return (<span>{ manifestecolidetail.quantity}{ manifestecolidetail.colidetail?.unite?.name} { manifestecolidetail.colidetail?.article?.name}, </span>)  }) }</label></td>
                    <td><label htmlFor={count}>{ manifestecoli.coli?.destination?.city } { manifestecoli.coli?.destination?.region }</label></td>
                </tr>
            )
        })

        return(
            <div>
                <div>{ this.state.title}</div>
                <form onSubmit={this.storeData} className={ (this.handleCheck("alouer budget") == true && !this.state.showform) ? "row" : "d-none"}>
                    <div className="text-center text-danger text-small small">{ this.state.error }</div>
                    <div className={"col-md-12 mt-2 mt-2 "}>
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Coli <span className="text-danger">*</span></label>
                            <div className="position-relative mt-1">
                                <Select
                                    className="form-control form-control-sm p-0"
                                    // value = {
                                    //     coliTables.filter(option => 
                                    //         this.state.coli?.id != null && this.state.coli?.id === option.id)
                                    // }
                                    required={true} 
                                    // defaultValue={ this.state.coli }
                                    placeholder={ "Selectionner coli*"}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                coli : select,
                                                quantity : select.quantity,
                                                qtMax : select.quantity
                                            })
                                        }
                                    }
                                    options={ coliTables }
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-6 mt-2   mt-2">
                        <div className="form-group has-icon-left">
                            <label htmlFor="nom-id-icon">Quantité<span className="text-danger">*</span></label>
                            <div className="position-relative mt-1">
                                <input type="text" className="form-control" placeholder=""  onChange={this.handleInput} name="quantity"  value={this.state.quantity} id="nom-id-icon" />
                            </div>
                        </div>
                    </div>
                    
                    <div className="d-end">
                        {/* <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => this.deleteBudget()} disabled={ this.state.btn }><i className="bi bi-trash"></i> Supprimer</button> */}
                        <button type="submit" className="btn btn-sm btn-outline-primary" disabled={ this.state.btn }><i className="bi bi-check"></i> Sauvegarder</button>
                    </div>
                </form>

                <div className={"tabs__content pt-30 js-tabs-content "}>
                    <div className="tabs__pane -tab-item-1 is-tab-el-active">
                        <div className="overflow-scroll scroll-bar-1">
                        <table className="table_css -border-bottom col-12">
                            <thead className="bg-light-2">
                                <tr  style={{ backgroundColor : "rgb(0, 0, 150)", color : "rgb(250, 250, 250)"}}>
                                    <th>#</th>
                                    <th>Client</th>
                                    <th>Coli</th>
                                    <th>Qté</th>
                                    <th>Prix</th>
                                    <th>Contenu</th>
                                    <th>Destination</th>
                                </tr>
                            </thead>
                            <tbody>
                                { colis }
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
                
        </div>
        )
    }
}
export default UpdateManifesteForm;
